import React, { useCallback, useRef } from 'react';
import { DURATION, useSnackbar } from 'baseui/snackbar';
import { RefreshSignedUrlInfo } from '../../../../../common/refresh-signed-url-info/refresh-signed-url-info';
export function useShowPreRefreshSnackbar() {
  const isShowingRef = useRef(false);
  const {
    enqueue,
    dequeue
  } = useSnackbar();
  return useCallback(() => {
    if (isShowingRef.current) {
      return Promise.resolve();
    }
    isShowingRef.current = true;
    return new Promise<void>(resolve => {
      const onTimerEnd = () => {
        dequeue();
        isShowingRef.current = false;
        resolve();
      };
      enqueue({
        message: <RefreshSignedUrlInfo onTimerEnd={onTimerEnd} />
      }, DURATION.infinite);
    });
  }, [enqueue, dequeue]);
}